<template>
  <Dialog header="Sequence"
          modal
          :visible="showDialog"
          @update:visible="hideHandler">
    <div class="flex justify-content-center form-editor">
      <div class="card">
        <form @submit.prevent="handleSubmit()" class="p-fluid">
          <div class="field">
            <div class="p-float-label">
              <AutoComplete
                  id="episode"
                  field="name"
                  v-model="item.episode"
                  :suggestions="suggestions"
                  :dropdown="true"
                  @complete="searchEpisode($event)"/>
              <label for="episode">Episode*</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <InputText id="name" v-model="item.name"/>
              <label for="name">Name*</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <InputText id="title" v-model="item.title"/>
              <label for="title">Title</label>
            </div>
          </div>
          <div class="field">
            <div class="p-float-label">
              <InputText id="dropbox" v-model="item.url"/>
              <label for="dropbox">Dropbox</label>
            </div>
          </div>
          <Button type="submit" label="Save" class="mt-2"/>
        </form>
      </div>
    </div>
  </Dialog>
</template>

<script>
import SequencesService from "@/services/entity/SequencesService";

export default {
  name: "SequenceDialog",
  props: {
    showDialog: Boolean,
    editItem: Object,
    episodes: Object
  },
  created() {
    this.sequenceService = new SequencesService();
  },
  computed: {
    item() {
      return this.editItem
    }
  },
  data(){
    return {
      filter: null,
      suggestions: null,
    }
  },
  methods: {
    handleSubmit() {
      if (this.item.id == null) {
        this.sequenceService.create(this.item).then(result => {
          this.item.id = result.id
          //this.item.saved = true
          //this.item.changed = false
          this.hideHandler()
        })
      } else {
        this.sequenceService.update(this.item).then(() => {
          //this.item.saved = true
          ///this.item.changed = false
          this.hideHandler()
        })
      }
    },
    hideHandler() {
      this.$emit("update:showDialog", false)
    },
    searchEpisode(event) {
      this.suggestions = this.episodes.filter(
          it => it.name.toLowerCase().includes(event.query.toLowerCase())
      )
    }
  }
}
</script>